module.exports = ".credito-image {\n  height: 100px;\n  width: auto; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/creditos/creditos.component.scss
// module id = ./src/app/creditos/creditos.component.scss
// module chunks = main